import { Button, Dropdown, Feed, Header, Icon, Item, Label } from "semantic-ui-react";
import { Notification } from "../models/Notification";
import moment from "moment";
import { MouseEvent } from "react";

type Props = {
  notifications?: Notification[];
  onDismissNotifications: (ids: string[]) => void;
};

function NotificationsMenu({ notifications, onDismissNotifications }: Props) {
  const notSeenCount = notifications?.filter((n) => !n.seen).length ?? 0;

  const handleDismissNotifications = (e: MouseEvent, ids: string[]) => {
    e.stopPropagation();
    onDismissNotifications(ids);
  };

  return (
    <Dropdown
      item
      trigger={
        <>
          {notSeenCount > 0 && <Label color="orange">{notSeenCount}</Label>}
          <Icon name="alarm" />
        </>
      }
    >
      <Dropdown.Menu
        direction="left"
        style={{
          minWidth: "300px",
        }}
      >
        <Dropdown.Item>
          <Item style={{ padding: "0" }}>
            <Item.Content>
              <Item.Extra>
                {notifications && notifications.length > 0 && (
                  <Button
                    basic
                    compact
                    onClick={(e) => {
                      handleDismissNotifications(
                        e,
                        notifications.map((n) => String(n.id))
                      );
                    }}
                  >
                    Dismiss all <Icon name="delete" />
                  </Button>
                )}
                {(!notifications || notifications.length === 0) && (
                  <Header as="h6">You don't have any nottifications</Header>
                )}
              </Item.Extra>
            </Item.Content>
          </Item>
        </Dropdown.Item>
        {notifications &&
          notifications.map((notification) => (
            <Dropdown.Item
              key={notification.id}
              style={{
                whiteSpace: "normal",
              }}
            >
              <Feed size="small">
                <Feed.Event>
                  <Feed.Content>
                    <Feed.Date>
                      {notification.organizationName} / {notification.projectName}
                      <div style={{ float: "right" }}>{moment(notification.dateCreatedUtc).local().fromNow()}</div>
                    </Feed.Date>

                    {!notification.seen && <Feed.Summary>{notification.text}</Feed.Summary>}
                    {notification.seen && <Feed.Extra text>{notification.text}</Feed.Extra>}

                    <Feed.Meta>
                      <Feed.Like
                        style={{ border: "0px", cursor: "pointer" }}
                        as="Button"
                        onClick={(e: MouseEvent) => {
                          handleDismissNotifications(e, [String(notification.id)]);
                        }}
                      >
                        <Icon name="delete" /> Dismiss
                      </Feed.Like>
                    </Feed.Meta>
                  </Feed.Content>
                </Feed.Event>
              </Feed>
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default NotificationsMenu;
